
























import Vue from 'vue';
import Component from 'vue-class-component';
import accountsApi from '@/api/accounts.api';
import * as ent from '@/entities';
import * as types from '@/store/types';
import adminsApi from '@/api/admins.api';

@Component({})
export default class MigrationPage extends Vue {

    public loading: boolean = true;
    public countForMigration: number = 0;

    public created() {
        adminsApi.countToMigrate().then((count) => {
            this.countForMigration = count;
            this.loading = false;
        });
    }

    public migrate() {
        let afterFn = async (closeFn: () => void) => {
            try {
                await accountsApi.migrate();
                this.$router.push('/app/agents');
            } finally {
                closeFn();
            }
        };
        let payload: ent.IConfirm = {
            heading: 'Do you want to migrate old agents from old server, marked as "Ready To Migrate"?',
            afterFn
        };

        this.$store.dispatch(types.SHOW_CONFIRM, payload);
        this.$store.dispatch(types.APIDATA_DASHBOARD_ENTER);
    }

}
